'use strict';
import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';

angular.module('pixels.ctrls', [])
    .controller('PixelManagerController', PixelManagerController)
    .controller('CreatePixelController', CreatePixelController)
    //Directive to search Pixels using enter key
    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    });

// Controller for getting Existing pixel conversions and to manage Pixels
PixelManagerController.$inject = ['$rootScope', '$scope', '$stateParams', '$timeout', 'UserService', 'ClusterService', '$state', '$ioAlert', '$modal', 'ModalService', 'pixelsService', 'FormService'];

function PixelManagerController($rs, $scope, $stateParams, $timeout, UserService, ClusterService, $state, $ioAlert, $modal, ModalService, pixelsService, FormService) {

    $scope.pixels = [];
    $scope.pixel = null;
    $scope.serviceId = [];
    $scope.pageObj = {
        perPageOptions: [1, 2, 50, 100],
        perPage: 50,
        search: '',
        currentPage: 1,
        totalCount: 0,
        startIndex: 1,
        endIndex: 1,
        maxSize: 5,
        calculate: function () {
            $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
            $scope.pageObj.endIndex = Math.min(($scope.pageObj.currentPage) * $scope.pageObj.perPage);
            if ($scope.pageObj.endIndex > $scope.pageObj.totalCount) {
                $scope.pageObj.endIndex = $scope.pageObj.totalCount;
            }
        }
    };
    $scope.$watch('pageObj.currentPage', function () {
        $scope.pageObj.calculate();
    });
    $scope.$watch('pageObj.perPage', function () {
        $scope.pageObj.calculate();
    });

    // To get All the Pixels or Existing Conversion List
    $scope.getExistingConversionList = function (orderBy) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Pixel Manager";

        var params = {
            "clusters": ClusterService.clusterIds,
            "XDEBUG_SESSION_START": "PHPSTORM"
        };
        params.pageNo = $scope.pageObj.currentPage;
        params.perPage = $scope.pageObj.perPage;
        params.searchTerm = $scope.pageObj.search;
        if (orderBy) {
            params.orderBy = orderBy;
            switch (params.orderBy) {
                case 'conversion_name':
                    params.orderBy = "conversion_name";
                    break;
                case 'cluster_name':
                    params.orderBy = "cluster_name";
                    break;
                case 'client_id':
                    params.orderBy = "client_id";
                    break;
                case 'pixel_source_type':
                    params.orderBy = "pixel_source_type";
                    break;
                case 'conversion_category':
                    params.orderBy = "conversion_category";
                    break;
                case 'service_name':
                    params.orderBy = "service_name";
                    break;
                case 'conversion_status':
                    params.orderBy = "conversion_status";
                    break;
                case 'created_at':
                    params.orderBy = "created_at";
                    break;
                case 'updated_at':
                    params.orderBy = "updated_at";
                    break;
            }
            if ($scope.sortReverse == true) {
                params.orderType = 'ASC';
            } else {
                params.orderType = 'DESC';
            }
        }

        // To get all the existing Pixel conversions GET Service call
        pixelsService.getExistingConversionList(params).then(function (success) {
            $scope.pixels = _.map(success.pixels, function (pixel) {
                pixel.created_at = moment(pixel.created_at).local().format('YYYY-MM-DD HH:mm');
                pixel.updated_at = moment(pixel.updated_at).local().format('YYYY-MM-DD HH:mm');

                return pixel;
            });
            $rs.loadingInProgress = false;
            $scope.pageObj.totalCount = success.totalCount;
            $scope.pageObj.currentPage = success.pageNo;
            $scope.pageObj.calculate();
        }, function (error) {
            $ioAlert.show('Error!', 'Could not get Pixels.', 'error');
            $rs.loadingInProgress = false;
        });
    };

    // Go to Create new pixel page routing
    $scope.createPixel = function () {
        $state.go('createPixel');
    }

    // Go to Edit Pixel Page routing
    $scope.showEditPixel = function (pixel) {
        $state.go('editPixel', {
            pixelId: pixel.id,
        });
    };

    // To show orders and Line items in Modal for Pixel Association 
    $scope.showOrders = function (pixel) {
        var data = {};
        data.pixel = pixel;
        ModalService.returnModalType('pixelToLineItem', data).result.then(function () { }, function (cancel) {
            console.log("cancel");
        })
    };

    // To open delete or disassociate Pixel model
    function deletePixelModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    // Delete or disassociate Pixel form Lineitem
    $scope.delete = function (pixel) {
        deletePixelModal('deletePixel', { pixelname: pixel.conversion_name }).result.then(function (selectedItem) {
            if (selectedItem == 'ok') {
                var obj = {
                    "pixelData": {
                        "clientId": pixel.client_id,
                        "pixelIds": [pixel.id],
                        "serviceId": pixel.pixel_service_id,
                        "clusterId": pixel.cluster_id
                    }
                };
                FormService.deleteConversionTracker(obj).then(function (data) {
                    if (data && data.errors) {
                        for (var i = 0, len = data.errors.length; i < len; i++) {
                            $ioAlert.show('Error!', data.errors[i], 'error');
                        }
                    } else if (data.values) {
                        if (data.values.length == 0) {
                            $ioAlert.show("Error!", "This pixel is not associated to any Lineitem to Disassociate.", 'error');
                        }
                    } else {
                        $ioAlert.show("Success!", "Pixel Disassociated Successfully", 'success');
                        $scope.getExistingConversionList();
                    }
                }, function (error) {
                    console.log("error", error);
                    $ioAlert.show('Error!', 'Could not Delete Pixel.', 'error');
                });
            }
        }, function () {
            // dismiss modal
        });
    };

    var init = function () {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        $scope.pageObj.totalCount = 0;
        $scope.isAdmin = ($rs.userRole.permissions == 'superadmin' || $rs.userRole.permissions == 'adops,admin');
    };
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function () {
            $rs.userRole = UserService.userRole;
            init();
        }, function () {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.$on('$destroy', function () {
        clusterSelector();
    });

    var clusterSelector = $rs.$on('ClusterChanged', function (event, args) {
        $scope.getExistingConversionList();
        $timeout(function () {
            $scope.customersActive = false;
            $scope.$apply();
        });
    });
}

// Controller for creating new pixels
CreatePixelController.$inject = ['$rootScope', '$timeout', '$scope', 'UserService', 'ClusterService', '$state', '$ioAlert', '$stateParams', 'ModalService', 'pixelsService', '$window', 'FormService'];

function CreatePixelController($rs, $timeout, $scope, UserService, ClusterService, $state, $ioAlert, $stateParams, ModalService, pixelsService, $window, FormService) {
    $scope.showPixelServiceImages = false;
    $scope.isVisiblePhoneConversionForm = false;
    $scope.websiteModel = {
        pixelData: {
            value: {
                sameValue: {
                    currencyValue: "",
                    fullCurrencyCode: {}
                },
                differentValue: {
                    currencyValue: "",
                    fullCurrencyCode: {}
                }
            },
            ctcLookbackWindow: {
                ctcValue: {}
            },
            viewThroughLookbackWindow: {
                viewThroughValue: {}
            }
        }
    };
    $scope.phoneModel = {
        pixelData: {
            value: {
                sameValue: {
                    currencyValue: "",
                    fullCurrencyCode: {}
                },
                differentValue: {
                    currencyValue: "",
                    fullCurrencyCode: {}
                }
            },
            ctcLookbackWindow: {
                ctcValue: {}
            }, 
            viewThroughLookbackWindow: {
                viewThroughValue: {}
            }
        }
    };
    $scope.obj = {};
    $scope.websiteWindowCustomDays = false;
    $scope.websiteViewThroughCustomDays = false;
    $scope.phoneViewThroughCustomDays = false;
    $scope.showPixelServices = false;
    $scope.model = {};
    $scope.currencies = [
        { name: 'Argentine Peso (ARS)', code: "ARS" },
        { name: "Australian Dollar (AUD A$)", code: "AUD" },
        { name: "Bolivian Boliviano (BOB)", code: "BOB" },
        { name: "Brazilian Real (BRL R$)", code: "BRL" },
        { name: "British Pound (GBP £)", code: "GBP" },
        { name: "Brunei Dollar (BND)", code: "BND" },
        { name: "Bulgarian Lev (BGN)", code: "BGN" },
        { name: "Canadian Dollar (CAD CA$)", code: "CAD" },
        { name: "Chilean Peso (CLP)", code: "CLP" },
        { name: "Chinese Yuan (CNY CN¥)", code: "CNY" },
        { name: "Colombian Peso (COP)", code: "COP" },
        { name: "Croatian Kuna (HRK)", code: "HRK" },
        { name: "Czech Koruna (CZK)", code: "CZK" },
        { name: "Danish Krone (DKK)", code: "DKK" },
        { name: "Egyptian Pound (EGP)", code: "EGP" },
        { name: "Euro (EUR €)", code: "EUR" },
        { name: "Fijian Dollar (FJD)", code: "FJD" },
        { name: "Hong Kong Dollar (HKD HK$)", code: "HKD" },
        { name: "Hungarian Forint (HUF)", code: "HUF" },
        { name: "Indian Rupee (INR ₹)", code: "INR" },
        { name: "Indonesian Rupiah (IDR)", code: "IDR" },
        { name: "Israeli New Shekel (ILS ₪)", code: "ILS" },
        { name: "Japanese Yen (JPY ¥)", code: "JPY" },
        { name: "Jordanian Dinar (JOD)", code: "JOD" },
        { name: "Kenyan Shilling (KES)", code: "KES" },
        { name: "Lithuanian Litas (LTL)", code: "LTL" },
        { name: "Malaysian Ringgit (MYR)", code: "MYR" },
        { name: "Mexican Peso (MXN MX$)", code: "MXN" },
        { name: "Moroccan Dirham (MAD)", code: "MAD" },
        { name: "New Taiwan Dollar (TWD NT$)", code: "TWD" },
        { name: "New Zealand Dollar (NZD NZ$)", code: "NZD" },
        { name: "Nigerian Naira (NGN)", code: "NGN" },
        { name: "Norwegian Krone (NOK)", code: "NOK" },
        { name: "Pakistani Rupee (PKR)", code: "PKR" },
        { name: "Peruvian Sol (PEN)", code: "PEN" },
        { name: "Philippine Piso (PHP)", code: "PHP" },
        { name: "Polish Zloty (PLN)", code: "PLN" },
        { name: "Romanian Leu (RON)", code: "RON" },
        { name: "Russian Ruble (RUB)", code: "RUB" },
        { name: "Saudi Riyal (SAR)", code: "SAR" },
        { name: "Serbian Dinar (RSD)", code: "RSD" },
        { name: "Singapore Dollar (SGD)", code: "SGD" },
        { name: "South African Rand (ZAR)", code: "ZAR" },
        { name: "South Korean Won (KRW ₩)", code: "KRW" },
        { name: "Sri Lankan Rupee (LKR)", code: "LKR" },
        { name: "Swedish Krona (SEK)", code: "SEK" },
        { name: "Swiss Franc (CHF)", code: "CHF" },
        { name: "Thai Baht (THB)", code: "THB" },
        { name: "Tunisian Dinar (TND)", code: "TND" },
        { name: "Turkish Lira (TRY)", code: "TRY" },
        { name: "Ukrainian Hryvnia (UAH)", code: "UAH" },
        { name: "United Arab Emirates Dirham (AED)", code: "AED" },
        { name: "Uruguayan Peso (UYU)", code: "UYU" },
        { name: "US Dollar (USD $)", code: "USD" },
        { name: "Venezuelan Bolívar (2008–2018) (VEF)", code: "VEF" },
        { name: "Vietnamese Dong (VND ₫)", code: "VND" }
    ];
    $scope.websiteConversionDays = [{ days: "", name: "Custom" }, { days: 90, name: "90 Days" }, { days: 60, name: "60 Days" }, { days: 45, name: "45 Days" }, { days: 30, name: "30 Days" }, { days: 28, name: "4 Weeks" }, { days: 21, name: "3 Weeks" }, { days: 14, name: "2 Weeks" }, { days: 7, name: "1 Week" }];
    $scope.phoneConversionDays = [{ days: '', name: "Custom" }, { days: 60, name: "60 Days" }, { days: 45, name: "45 Days" }, { days: 30, name: "30 Days" }, { days: 28, name: "4 Weeks" }, { days: 21, name: "3 Weeks" }, { days: 14, name: "2 Weeks" }, { days: 7, name: "1 Week" }];
    $scope.phoneConversionDaysForClicks = [{ days: '', name: "Custom" },{ days: 90, name: "90 Days" },{ days: 60, name: "60 Days" }, { days: 45, name: "45 Days" }, { days: 30, name: "30 Days" }, { days: 28, name: "4 Weeks" }, { days: 21, name: "3 Weeks" }, { days: 14, name: "2 Weeks" }, { days: 7, name: "1 Week" }];
    $scope.websiteViewThroughDays = [{ days: '', name: "Custom" }, { days: 30, name: "30 Days" }, { days: 28, name: "4 Weeks" }, { days: 21, name: "3 Weeks" }, { days: 14, name: "2 Weeks" }, { days: 7, name: "1 Week" }, { days: 3, name: "3 Days" }, { days: 1, name: "1 Day" }];
    $scope.attributionModel = [
        { name: "Data driven", tooltip: "'Data driven' gives distributed credit for the conversion to the clicked ads" },
        { name: "Last click", tooltip: "'Last click' gives all credit for the conversion to the last-clicked ad" }
    ];
    $scope.phoneCategories = [
        { name: "Purchase", tooltip: "When someone completes a purchase or checkout flow" },
        { name: "Lead", tooltip: "When someone calls your business and expresses an interest in your offering" },
        { name: "Sign up", tooltip: "When someone signs up for a free newsletter or trial, creates an account, or pre-registers" },
        { name: "Other", tooltip: "" }
    ];

    // Get All Clusters
    $scope.getBusinessUnits = function () {
        pixelsService.getClusters().then(function (success) {
            $scope.clusters = success.clusters;
        }, function (error) {
            $ioAlert.show('ERROR!', 'Could not get Clusters.', 'error');
        });
    };

    // Get Clients based on clientId
    $scope.showClientsByClusterId = function (clusterId) {
        $scope.clusterId = clusterId;
        var params = {
            "clusterId": clusterId
        };
        pixelsService.getClients(params).then(function (success) {
            $scope.clients = success.clients;
        }, function (error) {
            $ioAlert.show('ERROR!', 'Could not get Clients.', 'error');
        });
    };

    // Get All Pixel Services
    $scope.showPixelServicesByClientId = function (clientId) {
        $scope.clientId = clientId;
        $scope.showPixelServices = true;
        var params = {
            "clusterId": $scope.clusterId,
            "clientId": clientId
        };
        var obj = {
            "clientId": clientId
        }
        pixelsService.getClientMappingStatus(obj).then(function (success) {
            if (!success.isClientMappingAvailable) {
                $ioAlert.show('ERROR!', 'No account mapping for selected client', 'error');
                $scope.clientError = true;
            } else {
                $scope.clientError = false;
            }
        }, function (error) {
            $ioAlert.show('ERROR!', 'Could not get Client Mapping Status.', 'error');
        });
        pixelsService.getPixels(params).then(function (success) {
            $scope.pixelServices = success.values;
        }, function (error) {
            $ioAlert.show('ERROR!', 'Could not get Pixels.', 'error');
        });
    };

    // To get Pixel Conversion Type Images
    $scope.showPixelConversonImages = function () {
        $scope.pixelImagesObj = [
            { Name: "website", status: 'false', Photo: "/client/iotool/app/modules/pixels/images/website_conversion.png" },
            { Name: "phonecall", status: 'false', Photo: "/client/iotool/app/modules/pixels/images/Phone_calls_Conversion.png" }
        ];
    };

    // To show Phone Conversion Tracker form for Radio Buttons
    $scope.showPhoneConversionForm = function () {
        $scope.isVisiblePhoneConversionForm = true;
    }
    // Back to Pixel Manager Routing
    $scope.backtoPixelManager = function () {
        $state.go('pixelManager');
    }

    $scope.selectConversionTracker = function (pixelServiceId) {
        $scope.showPixelServiceImages = true;
        $scope.showPixelConversonImages();
        $scope.serviceId = pixelServiceId;
    }

    //Open Google Ads in another tab

    $scope.openGoogleAdsHelpTab = function () {
        $window.open("https://support.google.com/google-ads/answer/1722054?hl=en");
    }
    $scope.openGoogleAdsTab = function () {
        $window.open("https://ads.google.com/aw/conversions/attribution?ocid=305949330&authuser=0&__u=6135172485&__c=1756631170");
    }

    //Open Google Ads support for CallsFromAds to Phone Call conversion
    $scope.openCallsFromAdsSupportTab = function () {
        $window.open("https://support.google.com/google-ads/answer/6095882?hl=en");
    }

    //Open Google Ads support for callsFromWebsites to Phone Call conversion
    $scope.openCallsFromWebsitesSupportTab = function () {
        $window.open("https://support.google.com/google-ads/answer/6095883?hl=en");
    }

    $scope.selectConversionTrackerType = function (name, index) {
        $scope.pixelImagesObj[index].status = 'true';
        for (var i = 0; i < $scope.pixelImagesObj.length; i++) {
            if (i != index) {
                $scope.pixelImagesObj[i].status = 'false';
                $scope.isVisiblePhoneConversionForm = false;
                $scope.phoneModel.pixelData.phoneCallSource = 'false';
            }
        }
        $scope.conversionType = name;
    }

    //Form Validations
    $scope.ngKeyUp = function () {
        if ($scope.websiteModel.pixelData.conversionName) {
            var pattern = (/.{1,100}/g).test($scope.websiteModel.pixelData.conversionName);
            if (pattern) {
                $scope.websiteName = false;
            } else {
                $scope.websiteName = true;
            }
        }
        if ($scope.websiteModel.pixelData.value.sameValue.currencyValue) {
            var pattern = (/^\d{1,12}$/g).test($scope.websiteModel.pixelData.value.sameValue.currencyValue);
            if (pattern) {
                $scope.websiteSameValue = false;
            } else {
                $scope.websiteSameValue = true;
            }
        }
        if ($scope.websiteModel.pixelData.value.differentValue.currencyValue) {
            var pattern = (/^\d{1,12}$/g).test($scope.websiteModel.pixelData.value.differentValue.currencyValue);
            if (pattern) {
                $scope.websiteDifferentValue = false;
            } else {
                $scope.websiteDifferentValue = true;
            }
        }
        if ($scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days > 90 || $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days == 0) {
            $scope.websiteWindowCustomDays = true;
        } else {
            $scope.websiteWindowCustomDays = false;
        }
        if ($scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days < 7 && $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days > 0) {
            $scope.websiteWindowCustomDayWarnig = true;
        } else {
            $scope.websiteWindowCustomDayWarnig = false;
        }
        if ($scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days > 30 || $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days == 0) {
            $scope.websiteViewThroughCustomDays = true;
        } else {
            $scope.websiteViewThroughCustomDays = false;
        }
        if ($scope.phoneModel.pixelData.conversionName) {
            var pattern = (/.{1,100}/g).test($scope.phoneModel.pixelData.conversionName);
            if (pattern) {
                $scope.phoneName = false;
            } else {
                $scope.phoneName = true;
            }
        }
        if ($scope.phoneModel.pixelData.value.sameValue.currencyValue) {
            var pattern = (/^\d{1,12}$/g).test($scope.phoneModel.pixelData.value.sameValue.currencyValue);
            if (pattern) {
                $scope.phoneSameValue = false;
            } else {
                $scope.phoneSameValue = true;
            }
        }
        if ($scope.phoneModel.pixelData.value.differentValue.currencyValue) {
            var pattern = (/^\d{1,12}$/g).test($scope.phoneModel.pixelData.value.differentValue.currencyValue);
            if (pattern) {
                $scope.phoneDifferentValue = false;
            } else {
                $scope.phoneDifferentValue = true;
            }
        }
        if ($scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days > 30 || $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days == 0) {
            $scope.phoneViewThroughCustomDays = true;
        } else {
            $scope.phoneViewThroughCustomDays = false;
        }
        if($scope.phoneModel.pixelData.phoneCallSource == 'clicksFromWebsites'){
            if ($scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days > 90 || $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days == 0) {
                $scope.phoneWindowCustomDays = true;
            } else {
                $scope.phoneWindowCustomDays = false;
            }
        }else{
            if ($scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days > 60 || $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days == 0) {
                $scope.phoneWindowCustomDays = true;
            } else {
                $scope.phoneWindowCustomDays = false;
            }
        }
        if ($scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days < 7 && $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days > 0) {
            $scope.phoneWindowCustomDayWarnig = true;
        } else {
            $scope.phoneWindowCustomDayWarnig = false;
        }
        if ($scope.phoneModel.pixelData.phoneCallDuration > 9999) {
            $scope.phoneCallLenght = true;
        } else {
            $scope.phoneCallLenght = false;
        }
    }

    //Set default values to form fields
    $scope.setDafaultFormValues = function () {
        $scope.phoneModel.pixelData.category = $scope.phoneCategories[1].name;
        $scope.phoneModel.pixelData.phoneCallDuration = 60;
        $scope.phoneModel.pixelData.value.sameValue.fullCurrencyCode = $scope.currencies[53];
        $scope.phoneModel.pixelData.value.sameValue.currencyValue = 1;
        $scope.phoneModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[53];
        $scope.phoneModel.pixelData.value.differentValue.currencyValue = 1;
        $scope.phoneModel.pixelData.countingType = 'One Conversion';
        $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue = $scope.phoneConversionDays[3];
        $scope.phoneModel.pixelData.includeInConversions = true;
        $scope.phoneModel.pixelData.attributionModelType = $scope.attributionModel[0].name;
        $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[7];
        $scope.websiteModel.pixelData.value.sameValue.fullCurrencyCode = $scope.currencies[53];
        $scope.websiteModel.pixelData.value.sameValue.currencyValue = 1;
        $scope.websiteModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[53];
        $scope.websiteModel.pixelData.value.differentValue.currencyValue = 1;
        $scope.websiteModel.pixelData.countingType = 'Every Conversion';
        $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue = $scope.websiteConversionDays[4];
        $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[7];
        $scope.websiteModel.pixelData.includeInConversions = true;
        $scope.websiteModel.pixelData.attributionModelType = $scope.attributionModel[0].name;
        $scope.websiteModel.pixelData.trackingMethodType = 'Page Load';
    }

    // View Pixel/Conversion Tracker to edit
    $scope.editPixel = function (pixelId) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Pixel Information";
        var params = {
            "pixelId": pixelId
        };
        pixelsService.getPixelByIdToEdit(params).then(function (success) {
            if (success.error) {
                if (angular.isObject(success.error)) {
                    $ioAlert.show('ERROR!', success.error.Error, 'error');
                } else if (angular.isString(success.errors)) {
                    $ioAlert.show('ERROR!', success.errors, 'error');
                } else if (angular.isArray(success.errors)) {
                    for (var i = 0, len = success.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', success.errors[i], 'error');
                    }
                }
            }
            $scope.model.clusterId = success.pixelData.clusterId;
            $scope.showClientsByClusterId(success.pixelData.clusterId);
            $scope.clientError = false;
            $scope.model.clientId = success.pixelData.clientId;
            $scope.showPixelServicesByClientId(success.pixelData.clientId);
            $scope.model.conversionType = success.pixelData.type;
            $scope.selectConversionTracker(success.pixelData.serviceId);
            $scope.model.pixelServiceId = success.pixelData.serviceId;
            for (var i = 0; i < $scope.pixelImagesObj.length; i++) {
                if (success.pixelData.type == $scope.pixelImagesObj[i].Name) {
                    $scope.pixelImagesObj[i].status = 'true';
                } else {
                    $scope.pixelImagesObj[i].status = 'false';
                    $scope.isVisiblePhoneConversionForm = false;
                }
                $scope.conversionType = success.pixelData.type;
            }
            $scope.showPhoneConversionForm();

            if (success.pixelData.type == 'website') {
                if (success.pixelData.alwaysUseDefaultRevenueValue) {
                    $scope.websiteModel.pixelData.value.conversionValue = "sameValue";
                    for (var i = 0; i < $scope.currencies.length; i++) {
                        if ($scope.currencies[i].code == success.pixelData.value.currencyCode) {
                            $scope.websiteModel.pixelData.value.sameValue.fullCurrencyCode = $scope.currencies[i];
                        }
                    }
                    $scope.websiteModel.pixelData.value.sameValue.currencyValue = parseFloat(success.pixelData.value.currencyValue);
                    $scope.websiteModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[53];
                    $scope.websiteModel.pixelData.value.differentValue.currencyValue = 1;
                } else {
                    $scope.websiteModel.pixelData.value.conversionValue = "differentValue";
                    for (var i = 0; i < $scope.currencies.length; i++) {
                        if ($scope.currencies[i].code == success.pixelData.value.currencyCode) {
                            $scope.websiteModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[i];
                        }
                    }
                    $scope.websiteModel.pixelData.value.differentValue.currencyValue = parseFloat(success.pixelData.value.currencyValue);
                    $scope.websiteModel.pixelData.value.sameValue.fullCurrencyCode = $scope.currencies[53];
                    $scope.websiteModel.pixelData.value.sameValue.currencyValue = 1;
                }

                if (success.pixelData.ctcLookbackWindow) {
                    if (success.pixelData.ctcLookbackWindow.is_custom) {
                        $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue = $scope.websiteConversionDays[0];
                    } else {
                        for (var i = 0; i < $scope.websiteConversionDays.length; i++) {
                            if ($scope.websiteConversionDays[i].days == success.pixelData.ctcLookbackWindow.days) {
                                $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue = $scope.websiteConversionDays[i];
                            }
                        }
                    }
                    if ($scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                        $scope.websiteModel.pixelData.ctcLookbackWindow.value = $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.name;
                        $scope.websiteModel.pixelData.ctcLookbackWindow.days = $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days;
                        $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days = parseInt(success.pixelData.ctcLookbackWindow.days);
                        $scope.websiteModel.pixelData.ctcLookbackWindow.is_custom = true;
                    } else {
                        $scope.websiteModel.pixelData.ctcLookbackWindow.value = $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.name;
                        $scope.websiteModel.pixelData.ctcLookbackWindow.days = $scope.websiteModel.pixelData.ctcLookbackWindow.ctcValue.days;
                        $scope.websiteModel.pixelData.ctcLookbackWindow.is_custom = false;
                    }
                } else {
                    $scope.websiteModel.pixelData.ctcLookbackWindow = {};
                }

                if (success.pixelData.viewThroughLookbackWindow) {
                    if (success.pixelData.viewThroughLookbackWindow.is_custom) {
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[0];
                    } else {
                        for (var i = 0; i < $scope.websiteViewThroughDays.length; i++) {
                            if ($scope.websiteViewThroughDays[i].days == success.pixelData.viewThroughLookbackWindow.days) {
                                $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[i];
                            }
                        }
                    }
                    if ($scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name == 'Custom') {
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.value = $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.days = $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days = parseInt(success.pixelData.viewThroughLookbackWindow.days);
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.is_custom = true;
                    } else {
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.value = $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.days = $scope.websiteModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        $scope.websiteModel.pixelData.viewThroughLookbackWindow.is_custom = false;
                    }
                } else {
                    $scope.websiteModel.pixelData.viewThroughLookbackWindow = {};
                }
                $scope.websiteModel.pixelData.webmastersEmail = success.pixelData.webmastersEmail.toString();
                const mergeObj = { ...success.pixelData, ...$scope.websiteModel.pixelData };
                $scope.websiteModel.pixelData = mergeObj;
                delete $scope.websiteModel.pixelData['googleGlobalSiteTag'];
                delete $scope.websiteModel.pixelData['googleEventSnippet'];
                $rs.loadingInProgress = false;
            } else if (success.pixelData.type == 'phonecall') {
                if (success.pixelData.alwaysUseDefaultRevenueValue) {
                    $scope.phoneModel.pixelData.value.conversionValue = "sameValue";
                    for (var i = 0; i < $scope.currencies.length; i++) {
                        if ($scope.currencies[i].code == success.pixelData.value.currencyCode) {
                            $scope.phoneModel.pixelData.value.sameValue.fullCurrencyCode = $scope.currencies[i];
                        }
                    }
                    $scope.phoneModel.pixelData.value.sameValue.currencyValue = parseFloat(success.pixelData.value.currencyValue);
                } else {
                    $scope.phoneModel.pixelData.value.conversionValue = "differentValue";
                    for (var i = 0; i < $scope.currencies.length; i++) {
                        if ($scope.currencies[i].code == success.pixelData.value.currencyCode) {
                            $scope.phoneModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[i];
                        }
                    }
                    $scope.phoneModel.pixelData.value.differentValue.currencyValue = parseFloat(success.pixelData.value.currencyValue);
                    $scope.websiteModel.pixelData.value.differentValue.fullCurrencyCode = $scope.currencies[53];
                    $scope.websiteModel.pixelData.value.differentValue.currencyValue = 1;
                }

                if (success.pixelData.viewThroughLookbackWindow) {
                    if (success.pixelData.viewThroughLookbackWindow.is_custom) {
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[0];
                    } else {
                        for (var i = 0; i < $scope.websiteViewThroughDays.length; i++) {
                            if ($scope.websiteViewThroughDays[i].days == success.pixelData.viewThroughLookbackWindow.days) {
                                $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue = $scope.websiteViewThroughDays[i];
                            }
                        }
                    }
                    if ($scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name == 'Custom') {
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.value = $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.days = $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days = parseInt(success.pixelData.viewThroughLookbackWindow.days);
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.is_custom = true;
                    } else {
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.value = $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.days = $scope.phoneModel.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        $scope.phoneModel.pixelData.viewThroughLookbackWindow.is_custom = false;
                    }
                } else {
                    $scope.phoneModel.pixelData.viewThroughLookbackWindow = {};
                }

                if (success.pixelData.ctcLookbackWindow) {
                    if (success.pixelData.ctcLookbackWindow.is_custom) {
                        $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue = $scope.phoneConversionDays[0];
                    } else {
                        if(success.pixelData.phoneCallSource == 'clicksFromWebsites'){
                            for (var i = 0; i < $scope.phoneConversionDaysForClicks.length; i++) {
                                if ($scope.phoneConversionDaysForClicks[i].days == success.pixelData.ctcLookbackWindow.days) {
                                    $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue = $scope.phoneConversionDaysForClicks[i];
                                }
                            }
                        }else{
                            for (var i = 0; i < $scope.phoneConversionDays.length; i++) {
                                if ($scope.phoneConversionDays[i].days == success.pixelData.ctcLookbackWindow.days) {
                                    $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue = $scope.phoneConversionDays[i];
                                }
                            }
                        }
                    }
                    if ($scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                        $scope.phoneModel.pixelData.ctcLookbackWindow.value = $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.name;
                        $scope.phoneModel.pixelData.ctcLookbackWindow.days = $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days;
                        $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days = parseInt(success.pixelData.ctcLookbackWindow.days);
                        $scope.phoneModel.pixelData.ctcLookbackWindow.is_custom = true;
                    } else {
                        $scope.phoneModel.pixelData.ctcLookbackWindow.value = $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.name;
                        $scope.phoneModel.pixelData.ctcLookbackWindow.days = $scope.phoneModel.pixelData.ctcLookbackWindow.ctcValue.days;
                        $scope.phoneModel.pixelData.ctcLookbackWindow.is_custom = false;
                    }
                } else {
                    conversion.pixelData.ctcLookbackWindow = {};
                }
                $scope.phoneModel.pixelData.phoneCallDuration = parseInt(success.pixelData.phoneCallDuration);
                if (success.pixelData.phoneCallSource == 'callsFromWebsites' || success.pixelData.phoneCallSource == 'clicksFromWebsites') {
                    $scope.phoneModel.pixelData.webmastersEmail = success.pixelData.webmastersEmail.toString();
                }
                const mergeObj = { ...success.pixelData, ...$scope.phoneModel.pixelData };
                $scope.phoneModel.pixelData = mergeObj;
                if ($scope.phoneModel.pixelData.phoneCallSource == 'callsFromWebsites') {
                    delete $scope.phoneModel.pixelData['googleGlobalSiteTag'];
                    delete $scope.phoneModel.pixelData['googleEventSnippet'];
                } else if ($scope.phoneModel.pixelData.phoneCallSource == 'callsFromAds') {
                    delete $scope.phoneModel.pixelData['webmastersEmail'];
                    delete $scope.phoneModel.pixelData['googleGlobalSiteTag'];
                    delete $scope.phoneModel.pixelData['googleEventSnippet'];
                }
                $rs.loadingInProgress = false;
            }
        }, function (error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('ERROR!', 'Could not get Pixel.', 'error');
        });
    };

    // Cancel logic
    $scope.cancel = function () {
        $scope.backtoPixelManager();
    }

    // Save Conversion trackers/Pixel
    $scope.savePixel = function (conversion) {
        if ($scope.conversionType == 'website') {
            if (!conversion.pixelData.category || !conversion.pixelData.conversionName || $scope.websiteName || $scope.websiteSameValue || $scope.websiteDifferentValue || !conversion.pixelData.value.conversionValue || $scope.websiteWindowCustomDays || $scope.websiteViewThroughCustomDays || !conversion.pixelData.webmastersEmail) {
                if (!conversion.pixelData.category) {
                    $ioAlert.show('ERROR!', 'Please select category', 'error');
                } else if (!conversion.pixelData.value.conversionValue) {
                    $ioAlert.show('ERROR!', 'Please select currency', 'error');
                }
                else {
                    $ioAlert.show('ERROR!', 'Please check the required fields', 'error');
                }
                return;
            } else if (conversion.pixelData.value.conversionValue == 'sameValue') {
                if (conversion.pixelData.value.sameValue.currencyValue == 0 || !(conversion.pixelData.value.sameValue.currencyValue > 0)) {
                    $ioAlert.show('ERROR!', 'Please check the currency value', 'error');
                    return;
                }
            } else if (conversion.pixelData.value.conversionValue == 'differentValue') {
                if (!(conversion.pixelData.value.differentValue.currencyValue >= 0)) {
                    $ioAlert.show('ERROR!', 'Please fill the currency', 'error');
                    return;
                }
            }
            if (conversion.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                if (!conversion.pixelData.ctcLookbackWindow.ctcValue.days) {
                    $ioAlert.show('ERROR!', 'Please fill Conversion Window days', 'error');
                    return;
                }
            }
            if (conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name == 'Custom') {
                if (!conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.days) {
                    $ioAlert.show('Error!', 'Please fill View Through Window days', 'error');
                    return;
                }
            }
            conversion.pixelData.type = $scope.conversionType;
            conversion.pixelData.clientId = $scope.clientId;
            conversion.pixelData.serviceId = $scope.serviceId;
            conversion.pixelData.clusterId = $scope.clusterId;
            if (conversion.pixelData.ctcLookbackWindow) {
                if (conversion.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                    conversion.pixelData.ctcLookbackWindow.value = conversion.pixelData.ctcLookbackWindow.ctcValue.name;
                    conversion.pixelData.ctcLookbackWindow.days = conversion.pixelData.ctcLookbackWindow.ctcValue.days;
                    conversion.pixelData.ctcLookbackWindow.is_custom = true;
                } else {
                    conversion.pixelData.ctcLookbackWindow.value = conversion.pixelData.ctcLookbackWindow.ctcValue.name;
                    conversion.pixelData.ctcLookbackWindow.days = conversion.pixelData.ctcLookbackWindow.ctcValue.days;
                    conversion.pixelData.ctcLookbackWindow.is_custom = false;
                }
            } else {
                conversion.pixelData.ctcLookbackWindow = {};
            }

            if (conversion.pixelData.viewThroughLookbackWindow) {
                if (conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name == 'Custom') {
                    conversion.pixelData.viewThroughLookbackWindow.value = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                    conversion.pixelData.viewThroughLookbackWindow.days = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                    conversion.pixelData.viewThroughLookbackWindow.is_custom = true;
                } else {
                    conversion.pixelData.viewThroughLookbackWindow.value = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                    conversion.pixelData.viewThroughLookbackWindow.days = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                    conversion.pixelData.viewThroughLookbackWindow.is_custom = false;
                }
            } else {
                conversion.pixelData.viewThroughLookbackWindow = {};
            }

            if (conversion.pixelData.value.conversionValue == 'sameValue') {
                delete conversion.pixelData.value.currencyValue;
                conversion.pixelData.value.sameValue.currencyCode = conversion.pixelData.value.sameValue.fullCurrencyCode.code;
                conversion.pixelData.alwaysUseDefaultRevenueValue = true;
                conversion.pixelData.value.currencyCode = conversion.pixelData.value.sameValue.fullCurrencyCode.code;
                conversion.pixelData.value.currencyValue = conversion.pixelData.value.sameValue.currencyValue.toString();
            } else if (conversion.pixelData.value.conversionValue == 'differentValue') {
                delete conversion.pixelData.value.currencyValue;
                conversion.pixelData.value.differentValue.currencyCode = conversion.pixelData.value.differentValue.fullCurrencyCode.code;
                conversion.pixelData.alwaysUseDefaultRevenueValue = false;
                conversion.pixelData.value.currencyCode = conversion.pixelData.value.differentValue.fullCurrencyCode.code;
                conversion.pixelData.value.currencyValue = conversion.pixelData.value.differentValue.currencyValue.toString();
            }
            $scope.tempPixelConversionData = angular.copy(conversion);
            delete $scope.tempPixelConversionData.pixelData.ctcLookbackWindow['ctcValue'];
            delete $scope.tempPixelConversionData.pixelData.viewThroughLookbackWindow['viewThroughValue'];
            if ($scope.tempPixelConversionData.pixelData.value.conversionValue == 'sameValue') {
                delete $scope.tempPixelConversionData.pixelData.value.sameValue['fullCurrencyCode'];
            } else if ($scope.tempPixelConversionData.pixelData.value.conversionValue == 'differentValue') {
                delete $scope.tempPixelConversionData.pixelData.value.differentValue['fullCurrencyCode'];
            }
            $scope.tempPixelConversionData.pixelData.webmastersEmail = $scope.tempPixelConversionData.pixelData.webmastersEmail.split(',');

            var obj = JSON.parse(JSON.stringify($scope.tempPixelConversionData));
            var params = {
                "XDEBUG_SESSION_START": "PHPSTORM"
            }
            // POST api for adding Pixel Libraray
            if (!$scope.isEditing) {
                pixelsService.addConversionTracker(obj, params).then(function (response) {
                    if (response.errors) {
                        if (response.errors.ErrorReason == 'A conversion with this name already exists') {
                            $ioAlert.show('ERROR!', response.errors.ErrorReason, 'error');
                        } else if (angular.isString(response.errors)) {
                            $ioAlert.show('ERROR!', response.errors, 'error');
                        } else if (angular.isObject(response.errors)) {
                            $ioAlert.show('ERROR!', response.errors.Error, 'error');
                        } else if (angular.isArray(response.errors)) {
                            for (var i = 0, len = response.errors.length; i < len; i++) {
                                $ioAlert.show('ERROR!', response.errors[i], 'error');
                            }
                        }
                    } else {
                        $ioAlert.show('SUCCESS!', 'Pixel saved successfully.', 'success');
                        setTimeout(function () { $scope.backtoPixelManager(); }, 2000);
                    }
                }, function () {
                    $ioAlert.show('ERROR!', 'Saving Pixel failed. Please try again later.', 'error');
                });
            } else {
                FormService.editConversionTracker(obj).then(function (response) {
                    if (angular.isString(response.errors)) {
                        $ioAlert.show('ERROR!', response.errors, 'error');
                    } else if (angular.isObject(response.errors)) {
                        $ioAlert.show('ERROR!', response.errors.Error, 'error');
                    } else if (angular.isArray(response.errors)) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show("Success!", "Pixel updated successfully.", 'success');
                        setTimeout(function () { $scope.backtoPixelManager(); }, 2000);
                    }
                }, function (error) {
                    console.log("error", error);
                    $ioAlert.show('ERROR!', 'Updating Pixel failed. Please try again later.', 'error');
                });
            }
        } else if ($scope.conversionType == 'phonecall') {
            if (!conversion.pixelData.conversionName || $scope.phoneName || !conversion.pixelData.value.conversionValue || $scope.phoneSameValue || $scope.phoneDifferentValue || $scope.phoneViewThroughCustomDays || (conversion.pixelData.phoneCallSource != 'clicksFromWebsites' && !(conversion.pixelData.phoneCallDuration >= 0)) || $scope.phoneWindowCustomDays || (conversion.pixelData.phoneCallSource != 'clicksFromWebsites' && $scope.phoneCallLenght)) {
                if (!conversion.pixelData.value.conversionValue) {
                    $ioAlert.show('ERROR!', 'Please select currency', 'error');
                }
                else {
                    $ioAlert.show('ERROR!', 'Please check the required fields', 'error');
                }
                return;
            } else if (conversion.pixelData.value.conversionValue == 'sameValue') {
                if (conversion.pixelData.value.sameValue.currencyValue == 0 || !(conversion.pixelData.value.sameValue.currencyValue > 0)) {
                    $ioAlert.show('ERROR!', 'Please check the currency value', 'error');
                    return;
                }
            } else if (conversion.pixelData.value.conversionValue == 'differentValue') {
                if (!(conversion.pixelData.value.differentValue.currencyValue >= 0)) {
                    $ioAlert.show('ERROR!', 'Please fill the currency', 'error');
                    return;
                }
            }
            if (conversion.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                if (!conversion.pixelData.ctcLookbackWindow.ctcValue.days) {
                    $ioAlert.show('ERROR!', 'Please fill Conversion Window days', 'error');
                    return;
                }
            }
            if (conversion.pixelData.phoneCallSource == 'callsFromWebsites' || conversion.pixelData.phoneCallSource == 'clicksFromWebsites') {
                if (!conversion.pixelData.webmastersEmail) {
                    $ioAlert.show('ERROR!', 'Please check the required fields', 'error');
                    return;
                }
            }

            conversion.pixelData.type = $scope.conversionType;
            conversion.pixelData.clientId = $scope.clientId;
            conversion.pixelData.serviceId = $scope.serviceId;
            conversion.pixelData.clusterId = $scope.clusterId;
            if (conversion.pixelData.ctcLookbackWindow) {
                if (conversion.pixelData.ctcLookbackWindow.ctcValue.name == 'Custom') {
                    conversion.pixelData.ctcLookbackWindow.value = conversion.pixelData.ctcLookbackWindow.ctcValue.name;
                    conversion.pixelData.ctcLookbackWindow.days = conversion.pixelData.ctcLookbackWindow.ctcValue.days;
                    conversion.pixelData.ctcLookbackWindow.is_custom = true;
                } else {
                    conversion.pixelData.ctcLookbackWindow.value = conversion.pixelData.ctcLookbackWindow.ctcValue.name;
                    conversion.pixelData.ctcLookbackWindow.days = conversion.pixelData.ctcLookbackWindow.ctcValue.days;
                    conversion.pixelData.ctcLookbackWindow.is_custom = false;
                }
            } else {
                conversion.pixelData.ctcLookbackWindow = {};
            }
            if(conversion.pixelData.phoneCallSource == 'clicksFromWebsites'){
                if (conversion.pixelData.viewThroughLookbackWindow) {
                    if (conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name == 'Custom') {
                        conversion.pixelData.viewThroughLookbackWindow.value = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        conversion.pixelData.viewThroughLookbackWindow.days = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        conversion.pixelData.viewThroughLookbackWindow.is_custom = true;
                    } else {
                        conversion.pixelData.viewThroughLookbackWindow.value = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.name;
                        conversion.pixelData.viewThroughLookbackWindow.days = conversion.pixelData.viewThroughLookbackWindow.viewThroughValue.days;
                        conversion.pixelData.viewThroughLookbackWindow.is_custom = false;
                    }
                } else {
                    conversion.pixelData.viewThroughLookbackWindow = {};
                }
            }
            if (conversion.pixelData.value.conversionValue == 'sameValue') {
                delete conversion.pixelData.value.currencyValue;
                conversion.pixelData.value.sameValue.currencyCode = conversion.pixelData.value.sameValue.fullCurrencyCode.code;
                conversion.pixelData.alwaysUseDefaultRevenueValue = true;
                conversion.pixelData.value.currencyCode = conversion.pixelData.value.sameValue.fullCurrencyCode.code;
                conversion.pixelData.value.currencyValue = conversion.pixelData.value.sameValue.currencyValue.toString();
            } else if (conversion.pixelData.value.conversionValue == 'differentValue') {
                delete conversion.pixelData.value.currencyValue;
                conversion.pixelData.value.differentValue.currencyCode = conversion.pixelData.value.differentValue.fullCurrencyCode.code;
                conversion.pixelData.alwaysUseDefaultRevenueValue = false;
                conversion.pixelData.value.currencyCode = conversion.pixelData.value.differentValue.fullCurrencyCode.code;
                conversion.pixelData.value.currencyValue = conversion.pixelData.value.differentValue.currencyValue.toString();
            }
            $scope.tempPixelConversionData = angular.copy(conversion);
            delete $scope.tempPixelConversionData.pixelData.ctcLookbackWindow['ctcValue'];
            delete $scope.tempPixelConversionData.pixelData.viewThroughLookbackWindow['viewThroughValue'];
            if ($scope.tempPixelConversionData.pixelData.value.conversionValue == 'sameValue') {
                delete $scope.tempPixelConversionData.pixelData.value.sameValue['fullCurrencyCode'];
            } else if ($scope.tempPixelConversionData.pixelData.value.conversionValue == 'differentValue') {
                delete $scope.tempPixelConversionData.pixelData.value.differentValue['fullCurrencyCode'];
            }
            if ($scope.tempPixelConversionData.pixelData.phoneCallSource == 'callsFromWebsites' || $scope.tempPixelConversionData.pixelData.phoneCallSource == 'clicksFromWebsites') {
                $scope.tempPixelConversionData.pixelData.webmastersEmail = $scope.tempPixelConversionData.pixelData.webmastersEmail.split(',');
            }
            $scope.tempPixelConversionData.pixelData.phoneCallDuration = $scope.tempPixelConversionData.pixelData.phoneCallDuration.toString();
            var obj = JSON.parse(JSON.stringify($scope.tempPixelConversionData));
            var params = {
                "XDEBUG_SESSION_START": "PHPSTORM"
            }

            if (!$scope.isEditing) {
                pixelsService.addConversionTracker(obj, params).then(function (response) {
                    if (response.errors) {
                        if (response.errors.ErrorReason == 'A conversion with this name already exists') {
                            $ioAlert.show('ERROR!', response.errors.ErrorReason, 'error');
                        } else if (angular.isString(response.errors)) {
                            $ioAlert.show('ERROR!', response.errors, 'error');
                        } else if (angular.isObject(response.errors)) {
                            $ioAlert.show('ERROR!', response.errors.Error, 'error');
                        } else if (angular.isArray(response.errors)) {
                            for (var i = 0, len = response.errors.length; i < len; i++) {
                                $ioAlert.show('ERROR!', response.errors[i], 'error');
                            }
                        }
                    } else {
                        $ioAlert.show('SUCCESS!', 'Pixel saved successfully.', 'success');
                        setTimeout(function () { $scope.backtoPixelManager(); }, 2000);
                    }
                }, function () {
                    $ioAlert.show('ERROR!', 'Saving Pixel failed. Please try again later.', 'error');
                });
            } else {
                FormService.editConversionTracker(obj).then(function (response) {
                    if (angular.isString(response.errors)) {
                        $ioAlert.show('ERROR!', response.errors, 'error');
                    } else if (angular.isObject(response.errors)) {
                        $ioAlert.show('ERROR!', response.errors.Error, 'error');
                    } else if (angular.isArray(response.errors)) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show("Success!", "Pixel updated successfully.", 'success');
                        setTimeout(function () { $scope.backtoPixelManager(); }, 2000);
                    }
                }, function (error) {
                    console.log("error", error);
                    $ioAlert.show('ERROR!', 'Updating Pixel failed. Please try again later.', 'error');
                });
            }
        } else {
            $ioAlert.show('ERROR!', 'Please select Conversion Tracker type.', 'error');
        }

    };

    var init = function () {
        ClusterService.initCluster($rs.userRole, 'disabled');
        $scope.showPixelConversonImages();
        $scope.getBusinessUnits();
        if ($stateParams.pixelId) {
            $scope.editPixel($stateParams.pixelId);
            $scope.isEditing = true;
        } else {
            $scope.setDafaultFormValues();
            $scope.isEditing = false;
        }
    };
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function () {
            $rs.userRole = UserService.userRole;
            init();
        }, function () {
            $ioAlert.show('ERROR!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.$on('$destroy', function () {
        clusterSelector();
    });

    var clusterSelector = $rs.$on('ClusterChanged', function (event, args) {
        $timeout(function () {
            $scope.customersActive = false;
            $scope.$apply();
        });
    });
}